import React, { Component } from 'react';
import './Header.scss';
import languageService from '../../services/languageService';
import parameterService from '../../services/parameterService';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.state.languages = languageService.getAvailable();
        this.state.selectedLanguage = languageService.selected;

        languageService.onChange(() => {
            this.setState({
                languages: languageService.getAvailable(),
                selectedLanguage: languageService.selected
            });
        });
    }

    onSelectLanguage = event => {
        languageService.select(event.target.value);
    };

    render() {
        const logoUrl = parameterService.data.merchantLogo;

        return (
            <div className={['Header', logoUrl ? '': 'has-no-logo'].join(' ')}>
                <div className="navbar">
                    <a href={parameterService.paygate.URLBack || parameterService.paygate.urlback} className={['close', logoUrl ? '': 'has-no-logo'].join(' ')}>
                        Schließen
                    </a>
                    {logoUrl && (
                        <div className="navbar-brand ml-auto mr-auto">
                            <div className="shop-logo d-none d-sm-block" style={{backgroundImage: "url(" + logoUrl + ")"}}></div>
                            <div className="icn-shop-logo d-block d-sm-none" style={{backgroundImage: "url(" + logoUrl + ")"}}></div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js